<template>
  <v-spacer v-if="questionData?.ortographic_grade" class="mt-5">
    <span class="text-md font-medium">Análise linguística</span>
    <v-spacer class="border-solid border-[1px] border-b-[#E6E6E6] mt-2 mb-5" />
    <v-row>
      <v-col cols="12" md="6">
        <canvas id="radarChart"></canvas>
      </v-col>
      <v-col class="flex flex-col gap-4 justify-center" cols="12" md="6">
        <div>
          <h4 class="font-medium">Ortografia</h4>
          <span class="font-medium"
            >{{ questionData?.ortographic_grade?.ortography }}
            {{ questionData?.ortographic_grade?.ortography === 1 ? 'ponto' : 'pontos' }}</span
          >
          - {{ ortographyLegend?.[questionData?.ortographic_grade?.ortography] }}
        </div>
        <div>
          <h4 class="font-medium">Recursos Coesivos</h4>
          <span class="font-medium"
            >{{ questionData?.ortographic_grade?.cohesiveResources }}
            {{
              questionData?.ortographic_grade?.cohesiveResources === 1 ? 'ponto' : 'pontos'
            }}</span
          >
          -
          {{ cohesiveResourcesLegend?.[questionData?.ortographic_grade?.cohesiveResources] }}
        </div>
        <div>
          <h4 class="font-medium">Vocabulário</h4>
          <span class="font-medium"
            >{{ questionData?.ortographic_grade?.vocabulary }}
            {{ questionData?.ortographic_grade?.vocabulary === 1 ? 'ponto' : 'pontos' }}</span
          >
          - {{ vocabularyLegend?.[questionData?.ortographic_grade?.vocabulary] }}
        </div>
        <div>
          <h4 class="font-medium">Repertório</h4>
          <span class="font-medium"
            >{{ questionData?.ortographic_grade?.repertoire }}
            {{ questionData?.ortographic_grade?.repertoire === 1 ? 'ponto' : 'pontos' }}</span
          >
          - {{ repertoireLegend?.[questionData?.ortographic_grade?.repertoire] }}
        </div>
        <div>
          <div
            class="flex items-center gap-2 font-medium underline text-blue-500 cursor-pointer"
            @click="dialogOrtographyLegend = true"
          >
            <svg
              fill="none"
              height="20"
              viewBox="0 0 20 20"
              width="20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.99992 0.833252C8.18693 0.833252 6.41465 1.37087 4.9072 2.37811C3.39975 3.38536 2.22483 4.817 1.53103 6.49199C0.837224 8.16698 0.655693 10.0101 1.00939 11.7882C1.36309 13.5664 2.23613 15.1998 3.51811 16.4817C4.80009 17.7637 6.43344 18.6368 8.2116 18.9905C9.98976 19.3441 11.8329 19.1626 13.5079 18.4688C15.1828 17.775 16.6145 16.6001 17.6217 15.0926C18.629 13.5852 19.1666 11.8129 19.1666 9.99992C19.1637 7.56965 18.197 5.23974 16.4786 3.52127C14.7601 1.80281 12.4302 0.836119 9.99992 0.833252V0.833252ZM9.99992 17.4999C8.51656 17.4999 7.06652 17.0601 5.83315 16.2359C4.59978 15.4118 3.63848 14.2405 3.07083 12.87C2.50317 11.4996 2.35464 9.9916 2.64403 8.53674C2.93342 7.08188 3.64773 5.74551 4.69662 4.69662C5.74552 3.64772 7.08189 2.93342 8.53675 2.64403C9.9916 2.35464 11.4996 2.50316 12.87 3.07082C14.2405 3.63848 15.4118 4.59977 16.2359 5.83314C17.0601 7.06651 17.4999 8.51656 17.4999 9.99992C17.4975 11.9883 16.7065 13.8945 15.3005 15.3005C13.8945 16.7065 11.9883 17.4975 9.99992 17.4999V17.4999ZM9.99992 3.74992C8.76379 3.74992 7.55542 4.11647 6.52761 4.80323C5.4998 5.48999 4.69872 6.46611 4.22568 7.60815C3.75263 8.75019 3.62886 10.0069 3.87001 11.2192C4.11117 12.4316 4.70643 13.5453 5.58051 14.4193C6.45458 15.2934 7.56823 15.8887 8.78061 16.1298C9.99299 16.371 11.2497 16.2472 12.3917 15.7742C13.5337 15.3011 14.5099 14.5 15.1966 13.4722C15.8834 12.4444 16.2499 11.2361 16.2499 9.99992C16.2482 8.34286 15.5891 6.75417 14.4174 5.58245C13.2457 4.41073 11.657 3.75168 9.99992 3.74992V3.74992ZM9.99992 14.5833C9.09343 14.5833 8.20729 14.3144 7.45356 13.8108C6.69983 13.3072 6.11238 12.5914 5.76548 11.7539C5.41857 10.9164 5.32781 9.99483 5.50466 9.10575C5.68151 8.21668 6.11803 7.4 6.75902 6.75901C7.40001 6.11802 8.21668 5.6815 9.10576 5.50465C9.99484 5.3278 10.9164 5.41857 11.7539 5.76547C12.5914 6.11237 13.3072 6.69983 13.8108 7.45356C14.3144 8.20728 14.5833 9.09342 14.5833 9.99992C14.5819 11.2151 14.0986 12.3801 13.2394 13.2394C12.3801 14.0986 11.2151 14.5819 9.99992 14.5833ZM9.99992 6.66659C9.34065 6.66659 8.69619 6.86208 8.14802 7.22835C7.59986 7.59463 7.17262 8.11522 6.92032 8.72431C6.66803 9.33339 6.60202 10.0036 6.73064 10.6502C6.85926 11.2968 7.17673 11.8908 7.6429 12.3569C8.10908 12.8231 8.70302 13.1406 9.34962 13.2692C9.99623 13.3978 10.6664 13.3318 11.2755 13.0795C11.8846 12.8272 12.4052 12.4 12.7715 11.8518C13.1378 11.3037 13.3333 10.6592 13.3333 9.99992C13.3333 9.11586 12.9821 8.26802 12.3569 7.6429C11.7318 7.01777 10.884 6.66659 9.99992 6.66659V6.66659ZM9.99992 11.6666C9.67029 11.6666 9.34806 11.5688 9.07397 11.3857C8.79989 11.2026 8.58627 10.9423 8.46012 10.6377C8.33398 10.3332 8.30097 9.99807 8.36528 9.67477C8.42959 9.35147 8.58833 9.0545 8.82141 8.82141C9.0545 8.58832 9.35147 8.42959 9.67477 8.36528C9.99807 8.30097 10.3332 8.33397 10.6377 8.46012C10.9423 8.58627 11.2026 8.79989 11.3857 9.07397C11.5688 9.34805 11.6666 9.67028 11.6666 9.99992C11.6666 10.4419 11.491 10.8659 11.1784 11.1784C10.8659 11.491 10.442 11.6666 9.99992 11.6666Z"
                fill="#1C86E3"
              />
            </svg>
            Ver legenda das pontuações
          </div>
        </div>
      </v-col>
    </v-row>

    <v-dialog v-model="dialogOrtographyLegend" :max-width="500">
      <v-card>
        <v-card-title>
          <div class="flex items-center justify-between">
            <div class="flex items-center">
              <svg
                fill="none"
                height="20"
                viewBox="0 0 20 20"
                width="20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_10914_253)">
                  <path
                    d="M10 0.833344C8.18705 0.833344 6.41477 1.37096 4.90732 2.37821C3.39987 3.38545 2.22495 4.81709 1.53115 6.49208C0.837346 8.16707 0.655815 10.0102 1.00951 11.7883C1.36321 13.5665 2.23625 15.1998 3.51823 16.4818C4.80021 17.7638 6.43356 18.6368 8.21172 18.9905C9.98988 19.3442 11.833 19.1627 13.508 18.4689C15.183 17.7751 16.6146 16.6002 17.6219 15.0927C18.6291 13.5853 19.1667 11.813 19.1667 10C19.1638 7.56974 18.1972 5.23983 16.4787 3.52136C14.7602 1.8029 12.4303 0.836211 10 0.833344V0.833344ZM10 17.5C8.51669 17.5 7.06664 17.0601 5.83327 16.236C4.5999 15.4119 3.63861 14.2406 3.07095 12.8701C2.50329 11.4997 2.35477 9.99169 2.64416 8.53683C2.93354 7.08198 3.64785 5.7456 4.69674 4.69671C5.74564 3.64782 7.08201 2.93351 8.53687 2.64412C9.99173 2.35473 11.4997 2.50326 12.8702 3.07091C14.2406 3.63857 15.412 4.59986 16.2361 5.83323C17.0602 7.0666 17.5 8.51665 17.5 10C17.4976 11.9884 16.7067 13.8946 15.3007 15.3006C13.8947 16.7066 11.9884 17.4976 10 17.5V17.5ZM10 3.75001C8.76391 3.75001 7.55554 4.11657 6.52773 4.80333C5.49992 5.49008 4.69885 6.4662 4.2258 7.60824C3.75275 8.75028 3.62898 10.0069 3.87014 11.2193C4.11129 12.4317 4.70655 13.5453 5.58063 14.4194C6.45471 15.2935 7.56835 15.8888 8.78073 16.1299C9.99311 16.3711 11.2498 16.2473 12.3918 15.7743C13.5339 15.3012 14.51 14.5001 15.1967 13.4723C15.8835 12.4445 16.25 11.2361 16.25 10C16.2483 8.34295 15.5892 6.75426 14.4175 5.58254C13.2458 4.41082 11.6571 3.75177 10 3.75001V3.75001ZM10 14.5833C9.09355 14.5833 8.20741 14.3145 7.45368 13.8109C6.69996 13.3073 6.1125 12.5915 5.7656 11.754C5.4187 10.9165 5.32793 9.99493 5.50478 9.10585C5.68163 8.21677 6.11815 7.40009 6.75914 6.7591C7.40013 6.11811 8.2168 5.68159 9.10588 5.50474C9.99496 5.3279 10.9165 5.41866 11.754 5.76556C12.5915 6.11246 13.3073 6.69992 13.8109 7.45365C14.3146 8.20737 14.5834 9.09351 14.5834 10C14.5821 11.2152 14.0987 12.3802 13.2395 13.2395C12.3802 14.0987 11.2152 14.582 10 14.5833ZM10 6.66668C9.34077 6.66668 8.69631 6.86217 8.14815 7.22844C7.59998 7.59472 7.17274 8.11531 6.92045 8.7244C6.66815 9.33349 6.60214 10.0037 6.73076 10.6503C6.85938 11.2969 7.17685 11.8909 7.64302 12.357C8.1092 12.8232 8.70314 13.1407 9.34974 13.2693C9.99635 13.3979 10.6666 13.3319 11.2757 13.0796C11.8847 12.8273 12.4053 12.4001 12.7716 11.8519C13.1379 11.3037 13.3334 10.6593 13.3334 10C13.3334 9.11595 12.9822 8.26811 12.3571 7.64299C11.7319 7.01787 10.8841 6.66668 10 6.66668V6.66668ZM10 11.6667C9.67041 11.6667 9.34818 11.5689 9.0741 11.3858C8.80001 11.2027 8.58639 10.9424 8.46025 10.6378C8.3341 10.3333 8.30109 9.99816 8.3654 9.67486C8.42971 9.35156 8.58845 9.05459 8.82153 8.8215C9.05462 8.58841 9.35159 8.42968 9.6749 8.36537C9.9982 8.30106 10.3333 8.33406 10.6379 8.46021C10.9424 8.58636 11.2027 8.79998 11.3858 9.07406C11.569 9.34814 11.6667 9.67037 11.6667 10C11.6667 10.442 11.4911 10.866 11.1786 11.1785C10.866 11.4911 10.4421 11.6667 10 11.6667Z"
                    fill="#4A545E"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_10914_253">
                    <rect fill="white" height="20" width="20" />
                  </clipPath>
                </defs>
              </svg>
              <span class="ml-2 text-xs md:text-sm not-italic font-medium line-clamp-1">
                Legenda das pontuações
              </span>
            </div>
            <v-btn
              color="transparent"
              elevation="0"
              icon
              size="small"
              @click="dialogOrtographyLegend = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </v-card-title>
        <v-divider class="border-opacity-100" />
        <v-card-text>
          <div class="text-sm flex gap-3 flex-col">
            <div>
              <h4 class="font-medium">Ortografia</h4>
              <p>
                <span class="font-medium">0-1 pontos</span> - Muitos erros graves que afetam a
                compreensão
              </p>
              <p>
                <span class="font-medium">2-3 pontos</span>
                - Alguns erros graves ou muitos erros menores, mas sem grande impacto na compreensão
              </p>
              <p>
                <span class="font-medium">4-5 pontos</span> - Poucos ou nenhum erro de ortografia
              </p>
            </div>
            <div>
              <h4 class="font-medium">Recursos Coesivos</h4>
              <p>
                <span class="font-medium">0-1 pontos</span> - Falta de coesão, frases ou ideias
                desconectadas
              </p>
              <p>
                <span class="font-medium">2-3 pontos</span> - Uso adequado, mas sem sofisticação
              </p>
              <p>
                <span class="font-medium">4-5 pontos</span> - Uso variado e preciso de conectivos e
                recursos de coesão textual
              </p>
            </div>
            <div>
              <h4 class="font-medium">Vocabulário</h4>
              <p>
                <span class="font-medium">0-1 pontos</span> - Vocabular limitado, com muitas
                repetições e palavras simples
              </p>
              <p>
                <span class="font-medium">2-3 pontos</span> - Vocabular adequado, com algumas
                variações e palavras de nível médio
              </p>
              <p>
                <span class="font-medium">4-5 pontos</span> - Vocabular variado e sofisticado, com
                uso apropriado e contexto claro
              </p>
            </div>
            <div>
              <h4 class="font-medium">Repertório</h4>
              <p>
                <span class="font-medium">0-1 pontos</span> - Pouco repertório, com referências
                vagas ou inadequadas
              </p>
              <p>
                <span class="font-medium">2-3 pontos</span> - Repertório razoável, com referências
                claras, mas limitadas
              </p>
              <p>
                <span class="font-medium">4-5 pontos</span> - Repertório vasto, com referências
                culturais, históricas ou acadêmicas relevantes e bem integradas
              </p>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-spacer>
</template>

<script lang="ts" setup>
import { nextTick, onMounted, ref } from 'vue'
import {
  Chart,
  type ChartItem,
  Filler,
  Legend,
  LineElement,
  PointElement,
  RadarController,
  RadialLinearScale,
  Tooltip
} from 'chart.js'

Chart.register(
  RadarController,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
)

const props = defineProps({
  questionData: Object
})

const dialogOrtographyLegend = ref(false)

const ortographyLegend: Record<number, string> = {
  0: 'Muitos erros graves que afetam a compreensão',
  1: 'Muitos erros graves que afetam a compreensão',
  2: 'Alguns erros graves ou muitos erros menores, mas sem grande impacto na compreensão',
  3: 'Alguns erros graves ou muitos erros menores, mas sem grande impacto na compreensão',
  4: 'Poucos ou nenhum erro de ortografia',
  5: 'Poucos ou nenhum erro de ortografia'
}
const vocabularyLegend: Record<number, string> = {
  0: 'Vocabular limitado, com muitas repetições e palavras simples',
  1: 'Vocabular limitado, com muitas repetições e palavras simples',
  2: 'Vocabular adequado, com algumas variações e palavras de nível médio',
  3: 'Vocabular adequado, com algumas variações e palavras de nível médio',
  4: 'Vocabular variado e sofisticado, com uso apropriado e contexto claro',
  5: 'Vocabular variado e sofisticado, com uso apropriado e contexto claro'
}
const cohesiveResourcesLegend: Record<number, string> = {
  0: 'Falta de coesão, frases ou ideias desconectadas',
  1: 'Falta de coesão, frases ou ideias desconectadas',
  2: 'Uso adequado, mas sem sofisticação',
  3: 'Uso adequado, mas sem sofisticação',
  4: 'Uso variado e preciso de conectivos e recursos de coesão textual',
  5: 'Uso variado e preciso de conectivos e recursos de coesão textual'
}
const repertoireLegend: Record<number, string> = {
  0: 'Pouco repertório, com referências vagas ou inadequadas',
  1: 'Pouco repertório, com referências vagas ou inadequadas',
  2: 'Repertório razoável, com referências claras, mas limitadas',
  3: 'Repertório razoável, com referências claras, mas limitadas',
  4: 'Repertório vasto, com referências culturais, históricas ou acadêmicas relevantes e bem integradas',
  5: 'Repertório vasto, com referências culturais, históricas ou acadêmicas relevantes e bem integradas'
}

onMounted(async () => {
  await nextTick()
  const ctx = (document.getElementById('radarChart') as HTMLCanvasElement)?.getContext('2d')
  Chart.getChart(ctx as CanvasRenderingContext2D)?.destroy()
  new Chart(ctx as ChartItem, {
    type: 'radar',
    data: {
      labels: ['Ortografia', 'Vocabulário', 'Recursos Coesivos', 'Repertório'],
      datasets: [
        {
          data: [
            props.questionData?.ortographic_grade?.ortography || 0,
            props.questionData?.ortographic_grade?.vocabulary || 0,
            props.questionData?.ortographic_grade?.cohesiveResources || 0,
            props.questionData?.ortographic_grade?.repertoire || 0
          ],
          fill: true,
          backgroundColor: 'rgba(54, 162, 235, 0.2)',
          borderColor: 'rgb(54, 162, 235)',
          pointBackgroundColor: 'rgb(54, 162, 235)',
          pointBorderColor: '#fff',
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderColor: 'rgb(54, 162, 235)',
          pointRadius: 6,
          pointHoverRadius: 8
        }
      ]
    },
    options: {
      scales: {
        r: {
          min: 0,
          max: 5,
          ticks: {
            stepSize: 1,
            display: false
          },
          pointLabels: {
            display: true
          },
          startAngle: 0,
          grid: {
            circular: true,
            lineWidth: 2
          }
        }
      },
      elements: {
        line: {
          borderWidth: 3
        }
      },
      plugins: {
        legend: {
          display: false
        }
      }
    }
  })
})
</script>
